import { Stack, Typography } from "@mui/material";

// ----------------------------------------------------------------------

type Props = {
	title: string;
	description: string;
};

export const SectionTitle = ({ title, description }: Props) => {
	return (
		<Stack gap={0.5}>
			<Typography variant={"h6"}>{title}</Typography>
			<Typography variant='body2' color='text.secondary'>
				{description}
			</Typography>
		</Stack>
	);
};

export default SectionTitle;
